import { useState, ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  /** Controlled open state: when both `open` and `onToggle` are given, the
      parent owns the open/close (e.g. auto-expand Passports when a scan
      exists). When absent the component stays uncontrolled. */
  open?: boolean;
  onToggle?: (next: boolean) => void;
  right?: ReactNode;
  headerActions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

export default function CollapsibleSection({
  title,
  count,
  defaultOpen = true,
  open,
  onToggle,
  right,
  headerActions,
  footer,
  children,
}: CollapsibleSectionProps) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isOpen = open !== undefined && onToggle ? open : internalOpen;
  const setOpen = (next: boolean) => {
    if (open !== undefined && onToggle) onToggle(next);
    else setInternalOpen(next);
  };

  return (
    <div className="form-section collapsible-section">
      <div className="section-header">
        <button
          type="button"
          className="section-toggle"
          onClick={() => setOpen(!isOpen)}
          aria-expanded={isOpen}
        >
          <span className={`chevron ${isOpen ? 'open' : ''}`}>▶</span>
          <h2>
            {title}
            {count !== undefined ? ` (${count})` : ''}
          </h2>
        </button>
        {right}
      </div>
      {headerActions && isOpen && (
        <div className="section-header-actions">{headerActions}</div>
      )}
      {isOpen && (
        <div className="section-body">
          {children}
          {footer && <div className="section-footer">{footer}</div>}
        </div>
      )}
    </div>
  );
}
